import { useParams } from "react-router-dom";

import { useLoadData } from "../../../../hooks/useLoadData";
import { ApiResponse } from "../../../../models/api-response";
import { Employee } from "../../../../models/masters/employee";
import { SaveEmployeeComponent } from "./save-employee.component";
import { SiTrackPage } from "../../../../components/si-track-page";
import { usersApiKeyStore } from "../../../../api/users-api-key-store";
import { editEmployeeFormSchema } from "./edit-employee-form.schema";

export const EditEmployeePage = () => {
    const { id } = useParams();
    const { isLoading, data } = useLoadData<ApiResponse<Employee>>(usersApiKeyStore.getUserByID(Number(id)));
    return (
        <SiTrackPage title="Edit Employee" isLoading={isLoading}>
            {data && <SaveEmployeeComponent employee={data.data} yupSchema={editEmployeeFormSchema} />}
        </SiTrackPage>
    );
}